import React, { Suspense } from 'react'
import Card from '../../../../../../components/Card'
import Body from './Body'
import List from './List'
import EditModel from './EditModal'
import useToggleState from 'src/hooks/useToggleState'
import { faPencil } from '@fortawesome/free-solid-svg-icons'

interface ContactInfoProps {
  id: string
}

const ContactInfo: React.FC<ContactInfoProps> = (props) => {
  const { id } = props
  const [isOpen, , handleToggle] = useToggleState()
  return (
    <>
      <Card
        title='Contact Info'
        primaryAction={{
          key: 'edit',
          icon: faPencil,
          onClick: handleToggle,
          permissionKey: 'CAT_EDIT'
        }}
      >
        <Suspense fallback={<List candidate={undefined} />}>
          <Body id={id} />
        </Suspense>
      </Card>
      <EditModel id={id} isOpen={isOpen} toggle={handleToggle} />
    </>
  )
}

export default ContactInfo
